import {Dispatch, FC, ReactNode, SetStateAction, useEffect, useState} from 'react'
import {API_URL, isNotEmpty} from '../../../../../../_metronic/helpers'
import {Customer} from '../core/_models'
import {CustomInputs} from '../../../../../../_metronic/helpers/components/CustomInputs'
import axios from 'axios'
import {
  IInqueryEconomicCode,
  InqueryEconomicCode,
} from '../../../../auth/components/registeration/InqueryEconomicCode'
import {
  BuyerInquiryState,
  isBuyerPreInquirySatisfied,
} from '../../../../auth/components/registeration/buyerInquiryError'
import {useIsOnPremises} from '../../../../auth/core/useOnPremises'
import {CatalogChoice} from '../../../shared/catalog-responsive/CatalogChoice'
import {readCatalogSaveError} from '../../../shared/catalog-responsive/catalogSaveError'
import {showToast} from '../../../shared/toast/toast'
import {
  getBuyerEconomicCodeLength,
  getBuyerIdentifierMaxLength,
  isForeignPassport,
  normalizeBuyerIdentifier,
  validateBuyerContact,
  validateBuyerIdentifiers,
} from './buyerValidation'
import {BuyerPrefill} from './buyerTaxFile'

const CUSTOMER_URL = `${API_URL}/customer`

const buyerTypeOptions = [
  {value: 1, label: 'حقیقی', icon: 'la-user'},
  {value: 2, label: 'حقوقی', icon: 'la-building'},
  {value: 3, label: 'مشارکت مدنی', icon: 'la-user-friends'},
  {value: 4, label: 'اتباع غیر ایرانی', icon: 'la-user-tie'},
]

const CUSTOMER_SAVE_FALLBACK_ERROR = 'ذخیره خریدار انجام نشد. دوباره تلاش کنید.'

type Props = {
  callBack: (data: Customer | undefined) => void
  parentId?: number
  customer?: Customer
  type: {
    type: number | undefined
    setType: Dispatch<SetStateAction<number | undefined>>
  }
  /** A new buyer's identifiers from the chosen tax file or the typed identifier (read once, when the form opens). */
  prefill?: BuyerPrefill
}

const CustomerEditModalForm: FC<Props> = ({customer, parentId, callBack, type, prefill}) => {
  const onPremises = useIsOnPremises()
  const [first, setFirst] = useState(true)
  const [nationalCode, setNationalCode] = useState<string>(customer ? '' : prefill?.nationalCode || '')
  // A file without an economic code gets no name inquiry: its trade name is the only name there is.
  const [name, setName] = useState<string>(
    !customer && prefill && !prefill.economicCode ? prefill.suggestedName || '' : ''
  )
  const [zipCode, setZipCode] = useState<string>('')
  const [address, setAddress] = useState<string>('')
  const [branchCode, setBranchCode] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [mobile, setMobile] = useState<string>('')
  const [partner, setPartner] = useState<string>('')
  const [ecode, setEcode] = useState<string>(customer ? customer.ecd || '' : prefill?.economicCode || '')
  const [validate, setValidate] = useState(false)
  const [nationalCodeError, setNationalCodeError] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [loading, setLoading] = useState(false)
  const [inquerydata, setInqueryData] = useState<IInqueryEconomicCode>()
  const [inquiryState, setInquiryState] = useState<BuyerInquiryState>('idle')
  const [submitError, setSubmitError] = useState('')
  // A malformed postal code or mobile is said once the person leaves the field, not while typing it.
  const [touchedContact, setTouchedContact] = useState<{zipCode?: boolean; mobile?: boolean}>({})
  const contactErrors = validateBuyerContact(zipCode, mobile)
  const [versionMode, setVersionMode] = useState<'inPlace' | 'newVersion'>('newVersion')
  const [invoiceScope, setInvoiceScope] = useState<'futureOnly' | 'unsent' | 'all'>('futureOnly')

  const normalize = (value?: string | number) => `${value ?? ''}`.trim().replace(/\s+/g, ' ')
  const same = (left?: string | number, right?: string | number) =>
    normalize(left) === normalize(right)
  const currentType = type.type || 1
  const normalizedBranchCode = normalize(branchCode).replace(/^0+/, '')
  const originalBranchCode = normalize(customer?.bcd).replace(/^0+/, '')
  const identityChanged =
    !!customer &&
    (!same(customer.nid, nationalCode) ||
      !same(customer.ecd, ecode) ||
      !same(customer.zcd, zipCode) ||
      (customer.typ || 1) !== currentType ||
      originalBranchCode !== normalizedBranchCode)
  const otherInformationChanged =
    !!customer &&
    (!same(customer.nm, name) ||
      !same(customer.adr, address) ||
      !same(customer.tel, phone) ||
      !same(customer.mob, mobile) ||
      !same(customer.prt, partner))
  const hasCustomerChanges = identityChanged || otherInformationChanged

  useEffect(() => {
    if (!identityChanged) return
    setVersionMode('newVersion')
    if (invoiceScope === 'all') setInvoiceScope('futureOnly')
  }, [identityChanged, invoiceScope])
  useEffect(() => {
    if (isNotEmpty(branchCode)) {
      var cd = Number(branchCode)
      var _cd = cd.toString()
      if (cd == 0) _cd = ''
      if (cd > 0) {
        _cd = cd.toString().padStart(4, '0')
      }
      if (_cd.length > 4) {
        _cd = _cd.slice(0, 4)
      }
      setBranchCode(_cd)
    }
  }, [branchCode])
  useEffect(() => {
    if (first) {
      if (customer) {
        setNationalCode(customer.nid || '')
        setName(customer.nm || '')
        setPhone(customer.tel || '')
        setMobile(customer.mob || '')
        setPartner(customer.prt || '')
        setZipCode(customer.zcd || '')
        setBranchCode(customer.bcd || '')
        type.setType(customer.typ || 1)
        setAddress(customer.adr || '')
        setEcode(customer.ecd || '')
      }
      setFirst(false)
    } else if (type.type != (customer ? customer.typ || 1 : 1)) {
      setEcode('')
      setNationalCode('')
      setInqueryData(undefined)
      setInquiryState('idle')
      setSubmitError('')
      setLoading(false)
      setNationalCodeError('')
    }
  }, [customer, type.type])

  // useEffect(() => {
  //   axios.get(`${CUSTOMER_URL}/branch/${nationalCode}`).then((response) => {
  //     if (Number(response.data) > 0) {
  //       setNidChecked(false)
  //     } else {
  //       setNidChecked(true)
  //     }
  //   })
  // }, [nationalCode])

  useEffect(() => {
    const identifierErrors = validateBuyerIdentifiers(currentType, nationalCode, ecode)
    const economicCodeChanged =
      !customer || normalizeBuyerIdentifier(customer.ecd) !== normalizeBuyerIdentifier(ecode)
    const requiresInquiry = isNotEmpty(ecode) && economicCodeChanged
    const missingLegalIdentifier =
      currentType === 2 && !isNotEmpty(nationalCode) && !isNotEmpty(ecode)
    var error = !isNotEmpty(name)
    error =
      error || !isBuyerPreInquirySatisfied(requiresInquiry, inquerydata != undefined, inquiryState)
    error = error || missingLegalIdentifier
    error = error || !!identifierErrors.nationalCode || !!identifierErrors.economicCode
    const contactErrors = validateBuyerContact(zipCode, mobile)
    error = error || !!contactErrors.zipCode || !!contactErrors.mobile
    setValidate(!error)
  }, [nationalCode, name, type.type, ecode, zipCode, mobile, inquerydata, inquiryState, customer])

  useEffect(() => {
    if (!inquerydata) {
      return
    }

    if (!isNotEmpty(name) && isNotEmpty(inquerydata.nm)) {
      setName(inquerydata.nm)
    }
    if (!isNotEmpty(address) && isNotEmpty(inquerydata.address)) {
      setAddress(inquerydata.address || '')
    }
    if (!isNotEmpty(zipCode) && isNotEmpty(inquerydata.zipCode)) {
      setZipCode(inquerydata.zipCode || '')
    }
    // The name inquiry answered without a national identifier: keep the one the tax file gave.
    if (!isNotEmpty(nationalCode) && prefill?.fromTaxFile && isNotEmpty(prefill.nationalCode)) {
      setNationalCode(prefill.nationalCode || '')
    }
  }, [inquerydata])

  // The chosen file's trade name when the official name could not be read.
  useEffect(() => {
    if (
      (inquiryState === 'transient-failure' || inquiryState === 'validation-failure') &&
      !isNotEmpty(name) &&
      isNotEmpty(prefill?.suggestedName)
    ) {
      setName(prefill?.suggestedName || '')
    }
  }, [inquiryState])

  useEffect(() => {
    setNationalCodeError(checkNID())
  }, [nationalCode, ecode, type.type])

  const checkNID = () => {
    if (currentType === 2 && !isNotEmpty(nationalCode) && !isNotEmpty(ecode)) {
      return 'شناسه ملی یا شماره اقتصادی خریدار حقوقی باید وارد شود.'
    }
    return validateBuyerIdentifiers(currentType, nationalCode, ecode).nationalCode || ''
  }

  const save = async () => {
    if (validate) {
      setSubmitting(true)
      setSubmitError('')
      try {
        const response = await axios.post(`${CUSTOMER_URL}/${customer?.id}`, {
          nid: normalizeBuyerIdentifier(nationalCode),
          adr: address,
          ecd: normalizeBuyerIdentifier(ecode),
          zcd: zipCode,
          tel: phone,
          mob: mobile,
          prt: partner,
          nm: name,
          typ: type.type,
          bcd: branchCode,
          vm: versionMode,
          is: versionMode === 'inPlace' ? 'all' : invoiceScope,
          pid: parentId,
        })
        // A buyer whose tax file is not active is registered with this note (backend 714, item 10).
        if (response.data?.warning) showToast('warning', response.data.warning)
        callBack(response.data)
      } catch (error: unknown) {
        // The server's Persian reason, or ours; never an exception's English text (507). The form keeps its values.
        setSubmitError(readCatalogSaveError(error, CUSTOMER_SAVE_FALLBACK_ERROR))
      } finally {
        setSubmitting(false)
      }
    }
  }

  function getNationalCodeLabel(): ReactNode {
    switch (type.type) {
      case 1:
        return 'کد ملی'
      case 2:
        return 'شناسه ملی'
      case 3:
        return 'شناسه مشارکت مدنی'
      case 4:
        return 'کد فراگیر یا شماره گذرنامه'
      default:
        return <></>
    }
  }

  return (
    <>
      <div className='row my-3'>
        <div className='col-lg-12 col-md-12 mb-8'>
          {/* A segmented choice, two a row on a phone (507: the fourth radio fell off a 375px screen). */}
          <CatalogChoice
            legend='نوع خریدار'
            layout='grid'
            isRequired
            isDisabled={submitting}
            options={buyerTypeOptions}
            value={type.type}
            onChange={type.setType}
            hint='نوع نادرست، ارسال صورتحساب به سامانه مؤدیان را با خطا روبه‌رو می‌کند.'
          />
        </div>
        {/* <div className='col-lg-6 col-md-12 my-3'>
          {type <= 2 && (
            <CustomInputs
              type='text'
              label={type == 2 ? 'شناسه ملی' : 'کد ملی'}
              stateValue={{value: nationalId, setValue: setNationalId}}
              isDisabled={variableA !== undefined || submitting}
              error={nationalCodeError}
            />
          )}
        </div>
        {nidChecked == false && !isNotEmpty(nationalCodeError) && (
        <div className='row mt-5'>
          <div className='col-12 text-center'>
            <p>
              شناسه ملی خریدار تکراری است
              <br />
              پروفایل این خریدار قبلاً در پنل شما وارد شده‌است. می‌توانید با جستجوی شناسه ملی در این
              جدول، نسبت به ویرایش و یا افزودن شعبه جدید، اقدام نمایید.
            </p>
          </div>
        </div>
      )} */}

        <div className='col-lg-6 col-md-12 my-3'>
          <CustomInputs
            isDisabled={submitting}
            type='text'
            label='نام خریدار'
            isRequired
            stateValue={{value: name, setValue: setName}}
          />
        </div>
        <div className='col-lg-6 col-md-12 my-3'>
          {/* <CustomInputs
            isDisabled={submitting}
            type='text'
            max={type.type == 1 ? 14 : type.type == 2 ? 11 : 12}
            label={
              <>
                کد اقتصادی
                <span className='ms-2 text-warning'>*</span>
              </>
            }
            stateValue={{value: ecode, setValue: setEcode}}
          /> */}
          <InqueryEconomicCode
            inquerydata={{
              inquerydata: inquerydata,
              setInqueryData: setInqueryData,
            }}
            loading={{
              loading: loading,
              setLoading: setLoading,
            }}
            economicCode={{
              economicCode: ecode,
              setEconomicCode: setEcode,
            }}
            nationalCode={{
              nationalCode: nationalCode,
              setNationalCode: setNationalCode,
            }}
            expectedEconomicCodeLength={getBuyerEconomicCodeLength(currentType)}
            // A chosen tax file's economic code is asked at once for the official name and address.
            autoInquire={!customer && !!prefill?.fromTaxFile && isNotEmpty(prefill.economicCode)}
            validationError={
              validateBuyerIdentifiers(currentType, nationalCode, ecode).economicCode
            }
            isRequired={false}
            onInquiryStateChange={setInquiryState}
          />
        </div>
        {currentType >= 1 && currentType <= 4 && (
          <div className='col-lg-6 col-md-12 my-3'>
            <CustomInputs
              isDisabled={submitting}
              type='text'
              // A digits keypad for the Iranian identifiers; a passport number (type 4) has letters.
              digitsOnly={currentType !== 4}
              max={getBuyerIdentifierMaxLength(currentType)}
              label={<>{getNationalCodeLabel()}</>}
              error={nationalCodeError}
              stateValue={{value: nationalCode, setValue: setNationalCode}}
              hint={
                currentType === 4 ? (
                  <span className='text-gray-600 fs-8'>
                    کد فراگیر ۱۲ رقمی؛ برای خریدار غیرمقیمی که کد فراگیر ندارد، شماره گذرنامه
                    (حداکثر ۹ حرف و رقم لاتین). خریدار با شماره گذرنامه فقط در صورتحساب فروش ارز
                    پذیرفته می‌شود.
                  </span>
                ) : undefined
              }
            />
          </div>
        )}
        <div className='col-lg-6 col-md-12 my-3'>
          <CustomInputs
            isDisabled={submitting}
            type='text'
            // the buyer's number: a phone keypad, but no autofill with the user's own
            inputMode='tel'
            label='تلفن'
            stateValue={{value: phone, setValue: setPhone}}
          />
        </div>
        <div className='col-lg-6 col-md-12 my-3'>
          <CustomInputs
            isDisabled={submitting}
            type='text'
            digitsOnly
            inputMode='tel'
            label='موبایل خریدار (اختیاری)'
            max={11}
            onBlurFn={() => setTouchedContact((value) => ({...value, mobile: true}))}
            error={touchedContact.mobile ? contactErrors.mobile : undefined}
            hint={
              // An on-premises install sends buyers no SMS.
              onPremises ? undefined : (
                <span className='fs-7 text-gray-600'>
                  اعلان صدور صورتحساب و ارسال آن به سامانه مؤدیان به این شماره پیامک می‌شود.
                </span>
              )
            }
            stateValue={{value: mobile, setValue: setMobile}}
          />
        </div>
        <div className='col-lg-6 col-md-12 my-3'>
          <CustomInputs
            isDisabled={submitting}
            type='text'
            label='معرف'
            max={25}
            stateValue={{value: partner, setValue: setPartner}}
          />
        </div>
        <div className='col-lg-6 col-md-12 my-3'>
          {/* Text with a digits keypad, not type=number (507): that ignored maxLength and showed a decimal keypad.
              No max here: the effect above pads and cuts the code to four digits. */}
          <CustomInputs
            isDisabled={submitting}
            type='text'
            digitsOnly
            LTR
            label='کد شعبه مالیاتی'
            stateValue={{value: branchCode, setValue: setBranchCode}}
          />
        </div>
        <div className='col-lg-6 col-md-12 my-3'>
          <CustomInputs
            isDisabled={submitting}
            type='text'
            digitsOnly
            LTR
            max={10}
            label='کد پستی'
            onBlurFn={() => setTouchedContact((value) => ({...value, zipCode: true}))}
            error={touchedContact.zipCode ? contactErrors.zipCode : undefined}
            stateValue={{value: zipCode, setValue: setZipCode}}
          />
        </div>
        <div className='col-lg-6 col-md-12 my-3'>
          <CustomInputs
            isDisabled={submitting}
            type='textarea'
            label='آدرس'
            stateValue={{value: address, setValue: setAddress}}
          />
        </div>
      </div>
      <div className='row mt-5'>
        <div className='col-12'>
          {type.type == 1 &&
            !(
              isNotEmpty(nationalCode) &&
              ((isNotEmpty(zipCode) && zipCode.length == 10) || isNotEmpty(ecode))
            ) && (
              <div className='alert alert-dismissible bg-light-warning border-dashed border-warning d-flex flex-column flex-sm-row p-5 mb-10'>
                <span className='svg-icon svg-icon-2hx svg-icon-warning me-4 mb-5 mb-sm-0'>
                  <i className='las la-info fs-3x text-warning'></i>
                </span>
                <div className='d-flex flex-column pe-0 pe-sm-10'>
                  <h6 className='mb-1 text-warning'>اطلاعات ناقص</h6>
                  <span className='text-gray-600'>
                    <div>اطلاعات شخص حقیقی برای ارسال نوع اول کافی نیست</div>
                  </span>
                </div>
              </div>
            )}
          {type.type == 2 && !isNotEmpty(nationalCode) && (
            <div className='alert alert-dismissible bg-light-warning border-dashed border-warning d-flex flex-column flex-sm-row p-5 mb-10'>
              <span className='svg-icon svg-icon-2hx svg-icon-warning me-4 mb-5 mb-sm-0'>
                <i className='las la-info fs-3x text-warning'></i>
              </span>
              <div className='d-flex flex-column pe-0 pe-sm-10'>
                <h6 className='mb-1 text-warning'>اطلاعات ناقص</h6>
                <span className='text-gray-600'>
                  <div>اطلاعات حقوقی برای ارسال نوع اول کافی نیست</div>
                </span>
              </div>
            </div>
          )}
          {type.type == 3 && !isNotEmpty(ecode) && (
            <div className='alert alert-dismissible bg-light-warning border-dashed border-warning d-flex flex-column flex-sm-row p-5 mb-10'>
              <span className='svg-icon svg-icon-2hx svg-icon-warning me-4 mb-5 mb-sm-0'>
                <i className='las la-info fs-3x text-warning'></i>
              </span>
              <div className='d-flex flex-column pe-0 pe-sm-10'>
                <h6 className='mb-1 text-warning'>اطلاعات ناقص</h6>
                <span className='text-gray-600'>
                  <div>اطلاعات مشارکت مدنی برای ارسال نوع اول کافی نیست</div>
                </span>
              </div>
            </div>
          )}
          {type.type == 4 && !isNotEmpty(ecode) && (
            <div className='alert alert-dismissible bg-light-warning border-dashed border-warning d-flex flex-column flex-sm-row p-5 mb-10'>
              <span className='svg-icon svg-icon-2hx svg-icon-warning me-4 mb-5 mb-sm-0'>
                <i className='las la-info fs-3x text-warning'></i>
              </span>
              <div className='d-flex flex-column pe-0 pe-sm-10'>
                <h6 className='mb-1 text-warning'>اطلاعات ناقص</h6>
                <span className='text-gray-600'>
                  <div>
                    {isForeignPassport(nationalCode)
                      ? 'خریدار با شماره گذرنامه فقط در صورتحساب فروش ارز (الگوی ۲) قابل استفاده است.'
                      : 'اطلاعات اتباع غیر ایرانی برای ارسال نوع اول کافی نیست'}
                  </div>
                </span>
              </div>
            </div>
          )}
        </div>
        {customer && hasCustomerChanges && (
          <div className='col-12 mb-8'>
            <div
              className={`border rounded p-5 ${
                identityChanged
                  ? 'border-warning bg-light-warning'
                  : 'border-primary bg-light-primary'
              }`}
            >
              <div className='d-flex flex-wrap align-items-start justify-content-between gap-3 mb-5'>
                <div>
                  <h5 className='fw-bolder mb-2'>روش اعمال تغییرات خریدار</h5>
                  <div className='text-gray-700 fs-7'>
                    {identityChanged
                      ? 'اطلاعات هویتی اصلی تغییر کرده است؛ برای حفاظت از صورتحساب‌های ارسال‌شده، نسخه جدید الزامی است.'
                      : 'اطلاعات هویتی اصلی ثابت است؛ می‌توانید نسخه جدید بسازید یا همین رکورد را مستقیم ویرایش کنید.'}
                  </div>
                </div>
                <span
                  className={`badge ${
                    identityChanged ? 'badge-light-warning' : 'badge-light-primary'
                  } px-3 py-2`}
                >
                  {identityChanged ? 'تغییر هویتی' : 'تغییر غیرهویتی'}
                </span>
              </div>

              <div className='row g-3 mb-5'>
                <div className='col-md-6'>
                  <label
                    className={`d-flex gap-3 border rounded p-4 h-100 bg-white ${
                      versionMode === 'newVersion' ? 'border-primary' : ''
                    }`}
                  >
                    <input
                      type='radio'
                      name='customer-version-mode'
                      checked={versionMode === 'newVersion'}
                      onChange={() => setVersionMode('newVersion')}
                    />
                    <span>
                      <strong className='d-block mb-1'>ساخت نسخه جدید</strong>
                      <small className='text-gray-600'>
                        نسخه قبلی در سوابق می‌ماند و نسخه جدید برای استفاده‌های بعدی فعال می‌شود.
                      </small>
                    </span>
                  </label>
                </div>
                <div className='col-md-6'>
                  <label
                    className={`d-flex gap-3 border rounded p-4 h-100 bg-white ${
                      versionMode === 'inPlace' ? 'border-primary' : ''
                    } ${identityChanged ? 'opacity-50' : ''}`}
                  >
                    <input
                      type='radio'
                      name='customer-version-mode'
                      checked={versionMode === 'inPlace'}
                      disabled={identityChanged}
                      onChange={() => setVersionMode('inPlace')}
                    />
                    <span>
                      <strong className='d-block mb-1'>ویرایش مستقیم بدون نسخه</strong>
                      <small className='text-gray-600'>
                        همین رکورد و در نتیجه نمایش خریدار در تمام صورتحساب‌های متصل به آن تغییر
                        می‌کند.
                      </small>
                    </span>
                  </label>
                </div>
              </div>

              {versionMode === 'newVersion' && (
                <div>
                  <div className='fw-bold text-gray-800 mb-3'>
                    دامنه اتصال صورتحساب‌ها به نسخه جدید
                  </div>
                  <div className='row g-3'>
                    <div className='col-lg-4'>
                      <label
                        className={`d-flex gap-2 border rounded p-3 h-100 bg-white ${
                          invoiceScope === 'futureOnly' ? 'border-success' : ''
                        }`}
                      >
                        <input
                          type='radio'
                          name='customer-invoice-scope'
                          checked={invoiceScope === 'futureOnly'}
                          onChange={() => setInvoiceScope('futureOnly')}
                        />
                        <span>
                          <strong className='d-block'>فقط صورتحساب‌های جدید</strong>
                          <small className='text-gray-600'>
                            صورتحساب‌های فعلی دست‌نخورده می‌مانند.
                          </small>
                        </span>
                      </label>
                    </div>
                    <div className='col-lg-4'>
                      <label
                        className={`d-flex gap-2 border rounded p-3 h-100 bg-white ${
                          invoiceScope === 'unsent' ? 'border-success' : ''
                        }`}
                      >
                        <input
                          type='radio'
                          name='customer-invoice-scope'
                          checked={invoiceScope === 'unsent'}
                          onChange={() => setInvoiceScope('unsent')}
                        />
                        <span>
                          <strong className='d-block'>جدیدها و ارسال‌نشده‌ها</strong>
                          <small className='text-gray-600'>
                            {customer.uuc || 0} صورتحساب ارسال‌نشده به نسخه جدید متصل می‌شود.
                          </small>
                        </span>
                      </label>
                    </div>
                    <div className='col-lg-4'>
                      <label
                        className={`d-flex gap-2 border rounded p-3 h-100 bg-white ${
                          invoiceScope === 'all' ? 'border-success' : ''
                        } ${identityChanged ? 'opacity-50' : ''}`}
                      >
                        <input
                          type='radio'
                          name='customer-invoice-scope'
                          checked={invoiceScope === 'all'}
                          disabled={identityChanged}
                          onChange={() => setInvoiceScope('all')}
                        />
                        <span>
                          <strong className='d-block'>همه صورتحساب‌ها</strong>
                          <small className='text-gray-600'>
                            {customer.uc || 0} صورتحساب به نسخه جدید متصل می‌شود؛ برای تغییر هویتی
                            مجاز نیست.
                          </small>
                        </span>
                      </label>
                    </div>
                  </div>
                  {identityChanged && (customer.suc || 0) > 0 && (
                    <div className='text-warning fw-bold fs-7 mt-3'>
                      {customer.suc} صورتحساب ارسال‌شده با هویت قبلی حفظ خواهد شد.
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {/* Outside the grid row (507): as a .col-12 its negative margins shifted «ذخیره» off centre on a phone, and it
          stuck only while that last row was in view. The reason a save failed sits right above the button. */}
      <div className='mp-catalog-form-actions text-end'>
        {submitError && (
          <div className='alert alert-danger d-flex align-items-start gap-2 py-3' role='alert'>
            <i className='las la-exclamation-circle fs-2 text-danger' aria-hidden='true'></i>
            <span>{submitError}</span>
          </div>
        )}
        <button
          type='button'
          className='btn btn-success w-200px'
          disabled={!validate || submitting}
          onClick={save}
        >
          ذخیره
        </button>
      </div>
    </>
  )
}

export {CustomerEditModalForm}
